module.exports = __webpack_public_path__ + "img/session-thematique-2-TrankyDoo.ca2d5ed.jpg";